import React, { useEffect, useState, useRef } from "react";
// import { StaticMap, setRTLTextPlugin } from "react-map-gl";
import mapboxgl from 'mapbox-gl';
import { MapboxOverlay as DeckOverlay } from '@deck.gl/mapbox';
import { GeoJsonLayer, ArcLayer } from '@deck.gl/layers';
import DeckGL from "@deck.gl/react";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { InputText } from "primereact/inputtext";
import planningService from "@services/planning.service";
import { BlockUI } from 'primereact/blockui';
import 'mapbox-gl/dist/mapbox-gl.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from "primereact/inputswitch";
import { ListBox } from 'primereact/listbox';
import { Checkbox } from 'primereact/checkbox';
import { useImmer } from 'use-immer'
import { AutoComplete } from "primereact/autocomplete";
import * as turf from '@turf/turf';
import { ScrollPanel } from 'primereact/scrollpanel';
import { ColorPicker } from 'primereact/colorpicker';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { ContextMenu } from 'primereact/contextmenu';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import "src/styles/mapbox_controls.css"
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import RulerControl from "./ruler";
import "src/containers/Map/ruler/index.css"
// import { MapboxExportControl, Size, PageOrientation, Format, DPI } from "@watergis/mapbox-gl-export";
// import '@watergis/mapbox-gl-export/dist/mapbox-gl-export.css';
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

// mapboxgl.setRTLTextPlugin(
//   'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
//   null,
//   true // Lazy load the plugin
// );
function Map() {
  const mapContainerRef = useRef(null);
  const [blocked, setBlocked] = useState(false);
  const [mapStyle, setMapStyle] = useState('streets-v12');
  const [layers, SetLayers] = useImmer([]);
  let dataBase = [];
  const [cellDB, setCellDB] = useState([]);
  const [lng, setLng] = useState(51.3347);
  const [lat, setLat] = useState(35.7219);
  const [mouseLocation, setMouseLocation] = useState({ lat: 0, lng: 0 });
  const [zoom, setZoom] = useState(5);
  const [properties, setProperties] = useState([]);
  const [MAP, setMAP] = useState(null);
  const cm = useRef(null);
  const itemsMenu = [
    {
      label: 'Copy Cordinates', icon: 'pi pi-copy',
      command: () => {
        navigator.clipboard.writeText(`${mouseLocation.lat.toFixed(5)},${mouseLocation.lng.toFixed(5)}`);
      }
    },

    {
      separator: true
    },
    { label: 'Export Sites', icon: 'pi pi-copy' },
    { label: 'Export Cells', icon: 'pi pi-file-edit' }
  ];
  // let cellsInView = new Set();
  let minViweLong = 0;
  let maxViewLong = 0;
  let minViweLat = 0;
  let maxViewLat = 0;
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: zoom,
      scrollZoom: false
    });
    setMAP(map);
    function forwardGeocoder(query) {
      const matchingFeatures = [];
      // console.log(dataBase);
      let cells = dataBase.filter(p => p.SiteName && p.SiteName.indexOf(query) > -1)
      let unique = new Set();
      for (const cell of cells) {
        if (unique.has(cell.SiteName)) {
          continue;
        }
        unique.add(cell.SiteName);
        matchingFeatures.push({
          'type': 'Feature',
          'properties': {
            'title': cell.SiteName
          },
          'geometry': {
            'coordinates': [cell.LONGITUDE, cell.LATITUDE],
            'type': 'Point'
          },
          'place_name': `🛜 ${cell.SiteName}`,
          'center': [cell.LONGITUDE, cell.LATITUDE],
          'place_type': ['site']
        });
      }

      return matchingFeatures;
    }


    ///////////////////////////////////////////
    class PitchToggle {
      constructor({ bearing = -20, pitch = 70, minpitchzoom = null }) {
        this._bearing = bearing;
        this._pitch = pitch;
        this._minpitchzoom = minpitchzoom;
      }

      onAdd(map) {
        this._map = map;
        let _this = this;

        this._btn = document.createElement("button");
        this._btn.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d";
        this._btn.type = "button";
        this._btn["aria-label"] = "Toggle Pitch";
        this._btn.onclick = function () {
          if (map.getPitch() === 0) {
            let options = { pitch: _this._pitch, bearing: _this._bearing };
            if (_this._minpitchzoom && map.getZoom() > _this._minpitchzoom) {
              options.zoom = _this._minpitchzoom;
            }
            map.easeTo(options);
            _this._btn.className =
              "mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d";
          } else {
            map.easeTo({ pitch: 0, bearing: 0 });
            _this._btn.className =
              "mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d";
          }
        };

        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
        this._container.appendChild(this._btn);

        return this._container;
      }

      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }

    /* Idea from Stack Overflow https://stackoverflow.com/a/51683226  */
    class MapboxGLButtonControl {
      constructor({
        className = "",
        title = "",
        eventHandler = null
      }) {
        this._className = className;
        this._title = title;
        this._eventHandler = eventHandler;
      }

      onAdd(map) {
        this._btn = document.createElement("button");
        this._btn.className = "mapboxgl-ctrl-icon" + " " + this._className;
        this._btn.type = "button";
        this._btn.title = this._title;
        this._btn.onclick = this._eventHandler;

        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
        this._container.appendChild(this._btn);

        return this._container;
      }

      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }
    class MapboxGLDistanceAzimuthControl {
      onAdd(map) {
        this._className = "mapbox-gl-draw_point";
        this._title = "Draw Point";
        this._btn = document.createElement("button");
        this._btn.className = "mapboxgl-ctrl-icon" + " " + this._className;
        this._btn.type = "button";
        this._btn.title = this._title;
        this._btn.onclick = this.oneClick;

        this._container = document.createElement("div");
        this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
        this._container.appendChild(this._btn);

        return this._container;
      }
      oneClick(event) {
        console.log("event number 1", event);
        const geojson = {
          'type': 'FeatureCollection',
          'features': []
        };

        // Used to draw a line between points
        const linestring = {
          'type': 'Feature',
          'geometry': {
            'type': 'LineString',
            'coordinates': []
          }
        };
        map.addSource('geojson', {
          'type': 'geojson',
          'data': geojson
        });

        // Add styles to the map
        map.addLayer({
          id: 'measure-points',
          type: 'circle',
          source: 'geojson',
          paint: {
            'circle-radius': 5,
            'circle-color': '#000'
          },
          filter: ['in', '$type', 'Point']
        });
        map.addLayer({
          id: 'measure-lines',
          type: 'line',
          source: 'geojson',
          layout: {
            'line-cap': 'round',
            'line-join': 'round'
          },
          paint: {
            'line-color': '#000',
            'line-width': 2.5
          },
          filter: ['in', '$type', 'LineString']
        });
        map.on('click', (e) => {
          const features = map.queryRenderedFeatures(e.point, {
            layers: ['measure-points']
          });

          // Remove the linestring from the group
          // so we can redraw it based on the points collection.
          if (geojson.features.length > 1) geojson.features.pop();

          // Clear the distance container to populate it with a new value.
          // distanceContainer.innerHTML = '';

          // If a feature was clicked, remove it from the map.
          if (features.length) {
            const id = features[0].properties.id;
            geojson.features = geojson.features.filter(
              (point) => point.properties.id !== id
            );
          } else {
            const point = {
              'type': 'Feature',
              'geometry': {
                'type': 'Point',
                'coordinates': [e.lngLat.lng, e.lngLat.lat]
              },
              'properties': {
                'id': String(new Date().getTime())
              }
            };

            geojson.features.push(point);
          }

          if (geojson.features.length > 1) {
            linestring.geometry.coordinates = geojson.features.map(
              (point) => point.geometry.coordinates
            );

            geojson.features.push(linestring);

            // Populate the distanceContainer with total distance
            const value = document.createElement('pre');
            const distance = turf.length(linestring);
            value.textContent = `Total distance: ${distance.toLocaleString()}km`;
            // distanceContainer.appendChild(value);
            console.log(value);
          }

          map.getSource('geojson').setData(geojson);
        });


        map.on('mousemove', (e) => {
          const features = map.queryRenderedFeatures(e.point, {
            layers: ['measure-points']
          });
          // Change the cursor to a pointer when hovering over a point on the map.
          // Otherwise cursor is a crosshair.
          map.getCanvas().style.cursor = features.length
            ? 'pointer'
            : 'crosshair';
        });
      }
      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }
    /* Event Handlers */


    function two(event) {
      alert("Event handler when clicking on \r\n" + event.target.className);
      console.log("event number 2", event);
    }

    function drawElevation(event) {
      const lineData = {
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [
            [38.86588, 44.313497],
            [-71.12971, 44.25279]
          ]
        },
        properties: {}
      }
      map.addSource('line-data', {
        type: 'geojson',
        data: lineData
      });

      map.addLayer({
        id: 'line-line-data',
        type: 'line',
        source: 'line-data',
        paint: {
          'line-width': 4,
          'line-color': '#37a2eb'
        }
      });
      map.addSource('mapbox-dem', {
        type: 'raster-dem',
        url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
        tileSize: 512,
        maxzoom: 20
      });
      map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });

      // add draggable markers
      const marker0 = new mapboxgl.Marker({
        draggable: true,
        color: '#83f7a0'
      })
        .setLngLat(lineData.geometry.coordinates[0])
        .addTo(map);

      const marker1 = new mapboxgl.Marker({
        draggable: true,
        color: '#ed6461'
      })
        .setLngLat(lineData.geometry.coordinates[1])
        .addTo(map);

      // as the user drags a marker, update the data for the line and re-render it with setData()
      const updateLineData = (e, position) => {
        const { lng, lat } = e.target.getLngLat();
        lineData.geometry.coordinates[position] = [lng, lat];
        map.getSource('line-data').setData(lineData);
      };

      marker0.on('drag', (e) => {
        updateLineData(e, 0);
      });
      marker0.on('dragend', updateElevationProfile);

      marker1.on('drag', (e) => {
        updateLineData(e, 1);
      });
      marker1.on('dragend', updateElevationProfile);
      function updateElevationProfile() {
        // split the line into 1km segments
        const chunks = turf.lineChunk(lineData, 1).features;

        // get the elevation for the leading coordinate of each segment
        const elevations = [
          ...chunks.map((feature) => {
            return map.queryTerrainElevation(
              feature.geometry.coordinates[0]
            );
          }),
          // do not forget the last coordinate
          map.queryTerrainElevation(
            chunks[chunks.length - 1].geometry.coordinates[1]
          )
        ];
        console.log(elevations);
        // add dummy labels
        // myLineChart.data.labels = elevations.map(() => '');
        // myLineChart.data.datasets[0] = {
        //     data: elevations,
        //     fill: false,
        //     tension: 0.4
        // };
        // myLineChart.update();
      }
      updateElevationProfile();
    }

    /* Instantiate new controls with custom event handlers */
    // const ctrlPoint = new MapboxGLButtonControl({
    //   className: "mapbox-gl-draw_point",
    //   title: "Draw Point",
    //   eventHandler: one
    // });

    const ctrlPoint = new MapboxGLDistanceAzimuthControl();

    const ctrlPolygon = new MapboxGLButtonControl({
      className: "mapbox-gl-draw_polygon",
      title: "Draw Polygon",
      eventHandler: drawElevation
    });

    const ctrlElevation = new MapboxGLButtonControl({
      className: "mapbox-gl-draw_elevation",
      title: "Draw Elevation",
      eventHandler: drawElevation
    });
    const draw = new MapboxDraw({
      displayControlsDefault: false,
      // Select which mapbox-gl-draw control buttons to add to the map.
      controls: {
        polygon: true,
        // line_string: true,
        // point: true,
        trash: true
      },
      // Set mapbox-gl-draw to draw by default.
      // The user does not have to click the polygon control button first.
      // defaultMode: 'draw_polygon'
    });
    map.on('draw.create', updateArea);
    map.on('draw.delete', updateArea);
    map.on('draw.update', updateArea);
    map.on('draw.selectionchange', updateArea);
    map.on('draw.modechange', updateArea);
    map.on('draw.actionable', updateArea);

    function updateArea(e) {
      const data = draw.getSelected();
      console.log(data);
      console.log(e);

    }

    //////////////////////////////////////////////////////
    //https://github.com/mapbox/mapbox-gl-geocoder/blob/main/API.md
    map.addControl(
      new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        localGeocoder: forwardGeocoder,
        zoom: 14,
        placeholder: 'Enter code site or location',
        flyTo: true,
        limit: 15
      }), 'top-left'
    );

    map.addControl(new mapboxgl.NavigationControl());
    map.addControl(new mapboxgl.ScaleControl());
    map.getContainer().addEventListener('wheel', (e) => {
      const delta = e.deltaY;
      const zoomStep = 1; // Adjust as needed
      if (delta > 0) {
        // Scroll down (zoom out)
        map.zoomOut(zoomStep);
      } else {
        // Scroll up (zoom in)
        map.zoomIn(zoomStep);
      }
    });
    map.addControl(new RulerControl(), 'top-right');
    map.addControl(draw);
    // map.addControl(new PitchToggle({ minpitchzoom: 11 }), "top-right");

    // map.addControl(ctrlPoint, "top-right");

    map.addControl(new mapboxgl.FullscreenControl());
    map.on('mousemove', (e) => {
      setMouseLocation(e.lngLat);
    });
    //   map.on('style.load', () => {
    //     addAdditionalSourceAndLayer();
    // });
    map.on('style.load', async () => {
      // Add a new source from our GeoJSON data and
      // set the 'cluster' option to true. GL-JS will
      // add the point_count property to your source data.
      let newLayers = []
      let siteLayer = []
      // // console.log('style.load', layers);
      if (true) {
        setBlocked(true);
        // result = (await planningService.Post("/sector_geojson", {})).data;
        console.log(Date.now());
        dataBase = (await planningService.Post("/sector_geojson3", {})).data;
        // console.log("dataBase", dataBase);
        siteLayer = generateSiteLayer(dataBase);
        setCellDB(dataBase);
        // newLayers = generateCells(cells);
        // console.log(siteLayer);

        setBlocked(false);
        console.log(Date.now());

      }

      else {
        //newLayers = layers;
      }
      map.on('move', () => {

        setLng(map.getCenter().lng.toFixed(4));
        setLat(map.getCenter().lat.toFixed(4));

        const bounds = map.getBounds();

        const topRight = bounds.getNorthEast();
        const bottomLeft = bounds.getSouthWest();
        const maxLat = topRight.lat;
        const minLat = bottomLeft.lat;

        const maxLng = topRight.lng;
        const minLng = bottomLeft.lng;

        const currnetZoom = map.getZoom().toFixed(0);
        // console.log("currnetZoom", currnetZoom);
        // console.log("zoom", zoom);
        if (currnetZoom > 11) {
          // console.log("ksdfjhgksjfklsdjfhsklfhsdlk");
          // let LONGITUDE = parseFloat(cell.LONGITUDE);
          // let LATITUDE = parseFloat(cell.LATITUDE);
          // console.log(dataBase);
          let update = false;
          // console.log(`${minLng} < ${minViweLong} || ${maxViewLong} < ${maxLng} || ${minLat} <${minViweLat} ||${maxViewLat} < ${maxLat}`);
          // console.log(`${minLng < minViweLong} || ${maxViewLong < maxLng} || ${minLat < minViweLat} || ${maxViewLat < maxLat}`);
          if (minLng < minViweLong || maxViewLong < maxLng || minLat < minViweLat || maxViewLat < maxLat) {
            minViweLong = minLng - 0.5;
            maxViewLong = maxLng + 0.5;
            minViweLat = minLat - 0.5;
            maxViewLat = maxLat + 0.5;
            update = true;
          }

          // console.log("inRangeCells", inRangeCells);

          // console.log("cellsInView1", cellsInView);

          // for (const cell of inRangeCells) {
          //   if (!cellsInView.has(cell["Cell Name"])) {
          //     cellsInView.add(cell["Cell Name"]);
          //     update = true;
          //   }

          // }

          console.log("update", update);
          if (update) {
            let inRangeCells = dataBase.filter(p => minLng - 0.5 < p.LONGITUDE && p.LONGITUDE < maxLng + 0.5 && minLat - 0.5 < p.LATITUDE && p.LATITUDE < maxLat + 0.5);
            let layersX = generateCells(inRangeCells);
            SetLayers(layersX);
            for (const x of layersX) {
              const mySource = map.getSource(x.Name);
              if (mySource === undefined) {
                // console.log("mySource");
                map.addSource(x.Name, {
                  type: 'geojson',
                  data: x.Values
                });
                map.addLayer({
                  id: x.Name,
                  type: 'fill',
                  source: x.Name,
                  paint: {
                    'fill-color': ['get', 'color'],
                    'fill-opacity': 1,

                  },
                  minzoom: 12 // Hide the layer at zoom level 14 or higher
                });
                map.on("mouseenter", x.Name, () => {
                  map.getCanvas().style.cursor = "pointer";
                });
                map.on("mouseleave", x.Name, () => {
                  map.getCanvas().style.cursor = "default";
                });
                map.addLayer({
                  'id': x.Name + '_outline',
                  'type': 'line',
                  'source': x.Name,
                  'layout': {},
                  'paint': {
                    'line-color': '#2e3330',
                    'line-width': 1
                  },
                  minzoom: 12
                });
                // map.on('mouseenter', x.Name, (e) => {
                //   // Change the cursor style as a UI indicator.
                //   map.getCanvas().style.cursor = 'pointer';

                //   // Single out the first found feature.
                //   var feature = e.features[0];

                //   // Display a popup with the name of the county
                //   popup.setLngLat(e.lngLat)
                //     .setText(feature.properties.Name)
                //     .addTo(map);
                // });

                // map.on('mouseleave', x.Name, () => {
                //   map.getCanvas().style.cursor = '';
                //   popup.remove();
                // });
                map.on('click', x.Name, (e) => {
                  let properties = [];
                  for (const p in e.features[0].properties) {
                    properties.push({ name: p, value: e.features[0].properties[p] });
                  }
                  setProperties(properties);
                  setActiveIndex(1);
                  // new mapboxgl.Popup()
                  //   .setLngLat(e.lngLat)
                  //   .setHTML(e.features[0].properties.Name)
                  //   .addTo(map);
                });
              }
              else {
                console.log("mySource exsist");

                map.getSource(x.Name).setData(x.Values);
              }
            }
          }



        }
        console.log(maxLat, minLat, maxLng, minLng);
        setZoom(map.getZoom().toFixed(2));
      });
      // // Add a vector source for admin-1 boundaries
      // map.addSource("admin-1", {
      //   type: "vector",
      //   url: "mapbox://mapbox.boundaries-adm1-v4",
      //   promoteId: "mapbox_id"
      // });

      // // Define a filter for US worldview boundaries
      // let worldviewFilter = [
      //   "any",
      //   ["==", "all", ["get", "worldview"]],
      //   ["in", "IR", ["get", "worldview"]]
      // ];

      // // Add a style layer with the admin-1 source below map labels
      // map.addLayer(
      //   {
      //     id: "admin-1-fill",
      //     type: "fill",
      //     source: "admin-1",
      //     "source-layer": "boundaries_admin_1",
      //     filter: worldviewFilter,
      //     paint: {
      //       "fill-color": "#CCCCCC",
      //       "fill-opacity": 0.5
      //     }
      //   },
      //   // This final argument indicates that we want to add the Boundaries layer
      //   // before the `waterway-label` layer that is in the map from the Mapbox
      //   // Light style. This ensures the admin polygons are rendered below any labels
      //   "waterway-label"
      // );
      // let siteData = result.data.filter(p => p.Name = "sites");
      // console.log(siteData);
      map.addSource('sites', {
        type: 'geojson',
        data: siteLayer.Values,
        cluster: true,
        clusterMaxZoom: 11, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      });

      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'sites',
        filter: ['has', 'point_count'],
        paint: {
          // Use step expressions (https://docs.mapbox.com/style-spec/reference/expressions/#step)
          // with three steps to implement three types of circles:
          //   * Blue, 20px circles when point count is less than 100
          //   * Yellow, 30px circles when point count is between 100 and 750
          //   * Pink, 40px circles when point count is greater than or equal to 750
          'circle-color': [
            'step',
            ['get', 'point_count'],
            '#51bbd6',
            100,
            '#f1f075',
            750,
            '#f28cb1'
          ],
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40
          ]
        }
      });
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      });
      for (const ll of newLayers) {
        if (ll.Name == "sites") {
          continue;
        }
        map.addSource(ll.Name, {
          type: 'geojson',
          data: ll.Values
        });
        map.addLayer({
          id: ll.Name,
          type: 'fill',
          source: ll.Name,
          paint: {
            'fill-color': ['get', 'color'],
            'fill-opacity': 0.6,

          },
          minzoom: 12 // Hide the layer at zoom level 14 or higher
        });
        map.addLayer({
          'id': ll.Name + '_outline',
          'type': 'line',
          'source': ll.Name,
          'layout': {},
          'paint': {
            'line-color': '#000',
            'line-width': 1
          },
          minzoom: 12
        });
        map.on('mouseenter', ll.Name, (e) => {
          // Change the cursor style as a UI indicator.
          map.getCanvas().style.cursor = 'pointer';

          // Single out the first found feature.
          var feature = e.features[0];

          // Display a popup with the name of the county
          popup.setLngLat(e.lngLat)
            .setText(feature.properties.Name)
            .addTo(map);
        });

        map.on('mouseleave', ll.Name, () => {
          map.getCanvas().style.cursor = '';
          popup.remove();
        });
        map.on('click', ll.Name, (e) => {
          let properties = [];
          for (const p in e.features[0].properties) {
            properties.push({ name: p, value: e.features[0].properties[p] });
          }
          setProperties(properties);
          setActiveIndex(1);
          // new mapboxgl.Popup()
          //   .setLngLat(e.lngLat)
          //   .setHTML(e.features[0].properties.Name)
          //   .addTo(map);
        });
      }


      map.addLayer({
        'id': 'poi-labels',
        'type': 'symbol',
        'source': 'sites',
        'layout': {
          'text-field': ['get', 'Name'],
          'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
          'text-radial-offset': 3,
          'text-justify': 'auto',

        },

        'paint': {
          'text-color': '#202',
          'text-halo-color': '#fff',
          'text-halo-width': 2
        },
        minzoom: 12
      });

      // map.addLayer({
      //   'id': 'poi-labels',
      //   'type': 'symbol',
      //   'source': 'my-geojson-source',
      //   'layout': {
      //     'text-field': ['get', 'Name'],
      //     'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
      //     'text-radial-offset': 0.5,
      //     'text-justify': 'auto',
      //     'icon-image': ['get', 'icon']
      //   },
      //   minzoom: 12
      // });
      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'sites',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': ['get', 'point_count_abbreviated'],
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        }
      });

      map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'sites',
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': '#11b4da',
          'circle-radius': 4,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff'
        }
      });
      map.on('click', 'clusters', (e) => {
        const features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        const clusterId = features[0].properties.cluster_id;
        map.getSource('sites').getClusterExpansionZoom(
          clusterId,
          (err, zoom) => {
            if (err) return;
            map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
        );
      });
      map.on('click', 'unclustered-point', (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        let properties = [];
        for (const p in e.features[0].properties) {
          properties.push({ name: p, value: e.features[0].properties[p] });
        }
        setProperties(properties);
        setActiveIndex(1);
        // new mapboxgl.Popup()
        //   .setLngLat(e.lngLat)
        //   .setHTML(e.features[0].properties.Name)
        //   .addTo(map);


      });

      // const deckOverlay = new DeckOverlay({
      //   // interleaved: true,
      //   layers: [
      //     new GeoJsonLayer({
      //       id: 'airports',
      //       data: AIR_PORTS,
      //       // Styles
      //       filled: true,
      //       pointRadiusMinPixels: 2,
      //       pointRadiusScale: 2000,
      //       getPointRadius: f => 11 - f.properties.scalerank,
      //       getFillColor: [200, 0, 80, 180],
      //       // Interactive props
      //       pickable: true,
      //       autoHighlight: true,
      //       onClick: info =>
      //         // eslint-disable-next-line
      //         info.object && alert(`${info.object.properties.name} (${info.object.properties.abbrev})`),
      //       // beforeId: 'waterway-label' // In interleaved mode render the layer under map labels
      //     }),
      //     new ArcLayer({
      //       id: 'arcs',
      //       data: AIR_PORTS,
      //       dataTransform: d => d.features.filter(f => f.properties.scalerank < 4),
      //       // Styles
      //       getSourcePosition: f => [-0.4531566, 51.4709959], // London
      //       getTargetPosition: f => f.geometry.coordinates,
      //       getSourceColor: [0, 128, 200],
      //       getTargetColor: [200, 0, 80],
      //       getWidth: 1
      //     })
      //   ]
      // });

      // map.addControl(deckOverlay);
    });

    // Clean up on unmount
    return () => map.remove();
  }, []);
  function generateSiteLayer(cells) {
    let sites = new Set();
    let newLayer = {
      "Name": "sites",
      visiable: true,
      color: '#11b4da',
      "Values": {
        type: 'FeatureCollection',
        features: [],
      }
    }
    for (const cell of cells) {
      if (!cell.Tech) {
        continue;
      }

      let LONGITUDE = parseFloat(cell.LONGITUDE);
      let LATITUDE = parseFloat(cell.LATITUDE);

      if (isNaN(LONGITUDE) || isNaN(LATITUDE)) {
        continue;
      }
      var center = turf.point([
        LONGITUDE,
        LATITUDE,
      ], {
        "Name": cell.SiteName,
        "Region": cell.REGION,
        "Subregion": cell.SUBREGION,
        "Province": cell.PROVINCE,
        "City": cell.City,
        "LONGITUDE": cell.LONGITUDE,
        "LATITUDE": cell.LATITUDE,
      });


      if (!sites.has(cell.SiteName)) {
        // var site = turf.point([-75.343, 39.984]);
        newLayer["Values"]['features'].push(center);
        sites.add(cell.SiteName);
      }

    }
    return newLayer;
  }
  function generateCells(cells) {
    let newLayers = []
    try {
      for (const cell of cells) {
        if (!cell.Tech) {
          continue;
        }

        if (newLayers.filter(p => p.Name == cell.Tech).length == 0) {
          newLayers.push({
            Name: cell.Tech,
            visiable: true,
            color: "",
            Values: {
              type: 'FeatureCollection',
              features: [],
            }
          });
        }
        let LONGITUDE = parseFloat(cell.LONGITUDE);
        let LATITUDE = parseFloat(cell.LATITUDE);
        let AZIMUT = parseFloat(cell.AZIMUT);
        let distance = parseInt(cell.distance);
        if (isNaN(LONGITUDE) || isNaN(LATITUDE) || isNaN(AZIMUT) || isNaN(distance)) {
          continue;
        }
        var center = turf.point([
          LONGITUDE,
          LATITUDE,
        ]);
        let color = "";
        distance = (parseInt(cell.distance) + 1) * (0.015);
        switch (cell.Tech) {
          case '2G':
            color = '#fa0000';
            break;
          case '3G':
            color = '#00fa60';
            break;
          case 'LMBB':
            color = '#1d00fa';
            break;
          case 'LFBB':
            color = '#e1ff00';
            break;
          case '5G':
            color = '#ff00ff';
            break;

        }
        var cellTurf = null;
        try {
          cellTurf = turf.sector(
            center,
            distance,
            parseFloat(cell.AZIMUT) - 30,
            parseFloat(cell.AZIMUT) + 30
          );
          cellTurf.properties = {
            Name: cell["Cell Name"],
            color: color,
            ...cell

          };
        } catch (error) {
          console.log(error);
          continue;
        }
        let layer = newLayers.filter(p => p.Name == cell.Tech)[0];
        layer.color = color;
        layer["Values"]['features'].push(cellTurf);
      }
      // SetLayers(newLayers);
    } catch (error) {
      console.log(error);
    }
    return newLayers;
  }
  function generateCell(cell) {


    let layerx = {
      type: 'FeatureCollection',
      features: [],
    }
    if (!cell.Tech) {
      return layerx;
    }


    let LONGITUDE = parseFloat(cell.LONGITUDE);
    let LATITUDE = parseFloat(cell.LATITUDE);
    let AZIMUT = parseFloat(cell.AZIMUT);
    let distance = parseInt(cell.distance);
    if (isNaN(LONGITUDE) || isNaN(LATITUDE) || isNaN(AZIMUT) || isNaN(distance)) {
      return layerx;
    }
    var center = turf.point([
      LONGITUDE,
      LATITUDE,
    ]);
    let color = "";
    distance = (parseInt(cell.distance) + 1) * (0.015);
    switch (cell.Tech) {
      case '2G':
        color = '#fa0000';
        break;
      case '3G':
        color = '#00fa60';
        break;
      case 'LMBB':
        color = '#1d00fa';
        break;
      case 'LFBB':
        color = '#e1ff00';
        break;
      case '5G':
        color = '#ff00ff';
        break;

    }
    var cellTurf = null;
    try {
      cellTurf = turf.sector(
        center,
        distance,
        parseFloat(cell.AZIMUT) - 30,
        parseFloat(cell.AZIMUT) + 30
      );
      cellTurf.properties = {
        Name: cell["Cell Name"],
        color: color,
        ...cell

      };
    } catch (error) {
      console.log(error);
      return layerx;
    }
    layerx['features'].push(cellTurf);

    return layerx;
  }
  // const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
  // const [viewState, setViewState] = useState({
  //   longitude: 51.3347,
  //   latitude: 35.7219,
  //   zoom: 10,
  //   minZoom: 5,
  //   maxZoom: 18,
  //   pitch: 0,
  //   bearing: 0,
  // });
  // useEffect(() => {

  // }, []);
  const items = [
    {
      label: "Update",
      icon: "pi pi-refresh",
    },
    {
      label: "Delete",
      icon: "pi pi-times",
    },
  ];

  const startContent = (
    <React.Fragment>
      <span classclassName="p-input-icon-left">
        <i classclassName="pi pi-search" />
      </span>
      <Button
        raised
        icon="pi pi-plus"
        className="p-button-sm text-xs ml-1 h-10"
      />
      <Button
        raised
        icon="pi pi-print"
        className="p-button-sm text-xs ml-1 h-10"
      />
      <Button
        raised
        icon="pi pi-upload"
        className="p-button-sm text-xs ml-1 h-10"
      />
    </React.Fragment>
  );

  const centerContent = (
    ""
  );

  const endContent = (
    <React.Fragment>
      Zoom :{Math.floor(zoom)} |
      Lat :{mouseLocation.lat.toFixed(5)} |
      Long :{mouseLocation.lng.toFixed(5)}
    </React.Fragment>
  );

  const [activeIndex, setActiveIndex] = useState(0);

  let mapStyles = ["satellite-streets-v12", "light-v11", "dark-v11", "streets-v12", "outdoors-v12"]
  const [checked, setChecked] = useState(false);
  const layerTemplate = (option) => {
    return (
      <div className="flex align-items-center align-middle ">
        <ColorPicker value={option.color} onChange={(e) => { }} />
        <Checkbox className="mr-1 ml-1 " disabled={option.Name === "sites" ? true : false} onChange={e => {
          MAP.setLayoutProperty(option.Name, 'visibility', e.checked ? 'visible' : 'none');
          MAP.setLayoutProperty(option.Name + "_outline", 'visibility', e.checked ? 'visible' : 'none');

          let index = layers.findIndex(p => p.Name == option.Name);
          SetLayers(draft => {
            draft[index].visiable = e.checked;
          })
          setChecked(e.checked)
        }
        }
          checked={option.visiable}></Checkbox>

        <div>{option.Name}</div>
      </div>
    );
  };
  return (
    <><Splitter>
      <SplitterPanel size={15}>

        <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <AccordionTab header="Layers">
            <ListBox filter itemTemplate={layerTemplate} options={layers} optionLabel="Name" className="w-full md:w-14rem" />
          </AccordionTab>
          <AccordionTab header="Properties">
            <ScrollPanel style={{ width: '100%', height: '500px' }}>
              <DataTable value={properties} >
                <Column field="name" header="Name"></Column>
                <Column field="value" header="Value"></Column>
              </DataTable>
            </ScrollPanel>
          </AccordionTab>
          <AccordionTab header="Config">
            <form class="w-full max-w-sm">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                    Style
                  </label>
                </div>
                <div class="md:w-2/3">
                  <Dropdown value={mapStyle} onChange={(e) => { setMapStyle(e.value); MAP.setStyle('mapbox://styles/mapbox/' + mapStyle); }} options={mapStyles}
                    placeholder="Style" className="w-full md:w-14rem" />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-password">
                    Place
                  </label>
                </div>
                <div class="md:w-2/3">
                  <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-password">
                    Roads
                  </label>
                </div>
                <div class="md:w-2/3">
                  <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-password">
                    Transit
                  </label>
                </div>
                <div class="md:w-2/3">
                  <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
                </div>
              </div>
            </form>
          </AccordionTab>
        </Accordion>
      </SplitterPanel>

      <SplitterPanel size={85}>
        <div><Toolbar
          start={startContent}
          center={centerContent}
          end={endContent}
        /></div>
        <div><BlockUI blocked={blocked}>

          <div className='map-container' onContextMenu={(e) => cm.current.show(e)} style={{ height: "800px" }} ref={mapContainerRef} />

        </BlockUI></div>




      </SplitterPanel>
    </Splitter>
      <ContextMenu model={itemsMenu} ref={cm} breakpoint="767px" />

    </>

  );
}

export default Map;
